import { UNLIMITED_TIER } from "@chesshotel/constants";
import useTranslation from "next-translate/useTranslation";
import { FaInfinity } from "react-icons/fa";
import { useMembership } from "../../ducks/membership";
import { useUser } from "../../ducks/user";

export default function MembershipInfo() {
  const { t } = useTranslation("common");
  // const { t: lobbyT } = useTranslation("lobby");
  const { leagueGames, analyzes, tier } = useMembership();
  const { memberLoggedIn } = useUser();

  if (!memberLoggedIn) {
    return null;
  }

  return (
    <div
      className="hidden md:flex self-start bg-gray-200 border rounded-b-md 
      px-3 py-1.5 text-xs whitespace-nowrap"
    >
      <div className="mr-1 uppercase">{t("League games")}</div>
      <div className="font-bold">
        {tier === UNLIMITED_TIER ? <FaInfinity /> : leagueGames}
      </div>
      <div className="ml-2 mr-1 uppercase">{t("Analyzes")}</div>
      <div className="font-bold uppercase">
        {tier === UNLIMITED_TIER ? <FaInfinity /> : analyzes}
      </div>
    </div>
  );
}
